// extracted by mini-css-extract-plugin
module.exports = {"products":"Custom_01_products__1FRC9","product":"Custom_01_product__V9rZQ","title":"Custom_01_title__151UY"};